import DomainSelect from 'volta/components/domain-select';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import Supplier, { SupplierResourceName } from 'volta/models/supplier';
import { eqFilter, inFilter, lkFilter, niFilter } from 'volta/utils/filters-utils';

import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import type { TButtonSize } from './bv-btn';

interface SupplierSelectArgs {
  size?: TButtonSize;
  skuId?: string;
  warehouseId?: string;
}

export default class SupplierSelect extends DomainSelect<Supplier, SupplierSelectArgs> {
  get infiniteScroll() {
    return true;
  }

  get idKey() {
    return 'id';
  }

  async searchPromise({ search, selected, excluded }: Record<string, any>) {
    const query: IJsonApiQuery = {
      sort: 'description,code'
    };
    const filter: IJsonApiQuery['filter'] = {};

    if (search?.length) {
      filter['q'] = lkFilter(search);
    }

    if (selected?.length) {
      filter['selectedIds'] = inFilter(selected);
    } else if (excluded?.length) {
      filter['id'] = niFilter(excluded);
    }

    if (this.args.skuId?.length) {
      filter['skuId'] = eqFilter(`${this.args.skuId}`);
    }

    query.filter = filter;

    const decoratedQuery = this.args.beforeQuery?.(query) ?? query;

    return await this.infinity.model(
      SupplierResourceName.singular,
      decorateApiQuery(decoratedQuery),
      JsonApiInfinityModel
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    SupplierSelect: typeof SupplierSelect;
    'supplier-select': typeof SupplierSelect;
  }
}
